export const DEF_INVENTORY_ITEM_LITE = require("./definitions/DestinyInventoryItemLiteDefinition.json");
export const DEF_OBJECTIVE = require("./definitions/DestinyObjectiveDefinition.json");